/* istanbul ignore file */
// Ignoring this file for tests, because it is a basic clone of the EDAP one.

import XDIDHelper from './XDIDHelper';
import { getCookie } from '../../universal/utils/CookieUtil';

const canAccessWindow = typeof window !== 'undefined';
// eslint-disable-next-line no-underscore-dangle
const shouldLoadExternalScripts = canAccessWindow && window.__LOAD_EXTERNAL_SCRIPTS__ !== false;

if (canAccessWindow && shouldLoadExternalScripts && window.analyticsdatalayer.isExpediaDeployment) {
    (function XDIDSetterUpper(win) {
        const xdidHelper = new XDIDHelper(win.analyticsdatalayer);
        const visitorId = xdidHelper.getVisitorId();
        // eslint-disable-next-line prefer-destructuring
        const hostname = win.location.hostname;
        const egEnv = xdidHelper.adlExtractor('appenvironment', 'dev');
        const travelPixelParams = {
            guid: visitorId,
            serverPlatform: 'expedia',
            tpid: '',
            eapid: '',
            expUserId: '',
            amcv: '',
            inAuthId: '',
            emailHash: ''
        };

        xdidHelper.loadScript('https://b.travel-assets.com/travel-pixel-js/0.0.1/app.js');

        // eslint-disable-next-line no-param-reassign
        win.travelPixel = win.travelPixel || [];
        win.travelPixel.push((TravelPixelWaiter) => {
            const waiter = new TravelPixelWaiter(hostname, egEnv);
            // eslint-disable-line dot-notation
            waiter.loadXdidApi(travelPixelParams).then((ret) => {
                let xdid;

                // If the xdid was found on another site then it will exist in ret.v
                if (ret && ret.k && ret.k === 'xdid' && ret.v) {
                    xdid = ret.v;

                // In the case where no other sites have an xdid then we need to
                // pull it from our own cookie (for now, should be done in library)
                } else if (!ret) {
                    xdid = getCookie('xdid');
                }

                // If I found an xdid then we need to send it to Keychain via EDAP
                if (xdid) {
                    win.edap.push({
                        name: 'xdid.send',
                        data: {
                            xdid
                        }
                    });
                }
            });
        });
    }(window));
}
